import { NgClass } from '@angular/common'
import { Component, Input } from '@angular/core'

@Component({
	selector: 'app-title',
	imports: [NgClass],
	templateUrl: './title.html',
	styleUrl: './title.css',
})
export class Title {
	@Input() copy!: string
	@Input() size!: string
	@Input() class!: string
}
